import React from 'react';

import { useConfiguration } from '../../context/configurationContext';
import { LayoutComposer } from '../../components/index.js';
import TopbarContainer from '../TopbarContainer/TopbarContainer.js';
import FooterContainer from '../FooterContainer/FooterContainer.js';

import { StaticPage } from '../PageBuilder/PageBuilder.js';

import { buildLandingSchema } from './landingPageData';
import Hero from './sections/Hero';
import StatBar from './sections/StatBar';
import HowItWorks from './sections/HowItWorks';
import ValueProps from './sections/ValueProps';
import BoothTypes from './sections/BoothTypes';
import EventTypes from './sections/EventTypes';
import StateDirectory from './sections/StateDirectory';
import FAQ from './sections/FAQ';
import CTABanner from './sections/CTABanner';

import css from './LandingPageContent.module.css';

const PAGE_TITLE =
  'Photo Booth Rental Marketplace | Find & Book Photo Booths | White Label Experts';
const PAGE_DESCRIPTION =
  'Book photo booth rentals for weddings, corporate events, and galas across the US and Canada. Post a free RFP, compare live bids from 750+ service providers, and pay securely through White Label Experts.';

/**
 * Custom WLE landing page body.
 *
 * Reuses the template's StaticPage (SEO/SSR via Page + react-helmet-async),
 * LayoutComposer, TopbarContainer (current header), and FooterContainer
 * (current footer). Only the marketplace marketing sections are bespoke.
 */
const LandingPageContent = props => {
  const { currentPage } = props;
  const config = useConfiguration();
  const schema = buildLandingSchema(config.marketplaceRootURL);

  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage title={PAGE_TITLE} description={PAGE_DESCRIPTION} schema={schema}>
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {layoutProps => {
          const { Topbar, Main, Footer } = layoutProps;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage={currentPage} />
              </Topbar>
              <Main as="main" className={css.main}>
                <div className={css.root}>
                  <Hero />
                  <StatBar />
                  <HowItWorks />
                  <ValueProps />
                  <BoothTypes />
                  <EventTypes />
                  <StateDirectory />
                  <FAQ />
                  <CTABanner />
                </div>
              </Main>
              <Footer>
                <FooterContainer />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </StaticPage>
  );
};

export default LandingPageContent;
